export default __webpack_public_path__ + "static/media/WhiteNews_x600.0d0e9784.png";